import { lineStatus } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";
import StatusBadge from "@/pages/home/components/StatusBadge";

export default function LineStatus() {
  return (
    <section id="lines" className="border-y border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-page">
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              index="02 / 线路状态"
              title="当前可用线路一览，挑延迟低的先走"
              desc="每条线路都标注了区域、延迟与实时状态。遇到拥堵或维护中的线路，直接换列表里的其他可用线路即可。"
            />
            <span className="shrink-0 inline-flex items-center gap-2 font-label text-xs tracking-[0.2em] text-foreground-500">
              <i className="ri-refresh-line" /> 更新于 10-10 09:20
            </span>
          </div>

          <div className="mt-9 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-5 py-3 font-label text-xs text-foreground-500 md:grid">
              <span className="col-span-4">线路名称</span>
              <span className="col-span-4">域名 / 地址</span>
              <span className="col-span-1">延迟</span>
              <span className="col-span-3 text-right">状态 / 操作</span>
            </div>

            {lineStatus.map((line) => (
              <div
                key={line.id}
                className="grid grid-cols-1 items-center gap-3 border-b border-background-200 px-5 py-4 last:border-0 md:grid-cols-12 md:gap-4"
              >
                <div className="flex items-center gap-3 md:col-span-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-xs font-medium text-secondary-800">
                    {line.id}
                  </span>
                  <span className="text-sm font-medium text-foreground-900">{line.name}</span>
                </div>
                <div className="break-all font-mono text-sm text-foreground-600 md:col-span-4">
                  {line.domain}
                </div>
                <div className="text-sm text-foreground-700 md:col-span-1">{line.latency}</div>
                <div className="flex items-center gap-3 md:col-span-3 md:justify-end">
                  <StatusBadge level={line.level} status={line.status} />
                  <button
                    type="button"
                    className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-3 py-1.5 text-xs text-primary-700 transition-colors hover:bg-primary-50"
                  >
                    打开 <i className="ri-external-link-line" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}